import { useState } from "react";

// Custom hook
export default function useToken() {
  const getToken = () => {
    const userToken = localStorage.getItem("token");
    return userToken;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    localStorage.setItem("token", userToken);
    setToken(userToken);
  };

  const removeToken = () => {
    localStorage.removeItem("token");
    setToken("");
  };

  return {
    token,
    setToken: saveToken,
    destroyToken: removeToken,
  };
}
